import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
function fetchScopePermissions() {
  return fetch("GET", qualifyUrl(ApiRoutes.EntityScopeController.getScope().url));
}
const useGetPermissionsByScope = (entity = void 0) => {
  var _a;
  const { data, isLoading } = useQuery({
    queryKey: ["scope-permissions"],
    queryFn: () => onError(fetchScopePermissions(), (e) => UserNotification.error(e.message)),
    retry: 1,
    // cache for 3 hours
    gcTime: 1e3 * 60 * 60 * 3,
    // data is valid for 3 hours
    staleTime: 1e3 * 60 * 60 * 3
  });
  const scope = ((_a = entity == null ? void 0 : entity._scope) == null ? void 0 : _a.toUpperCase()) || "DEFAULT";
  const permissions = isLoading ? { is_mutable: false, is_deletable: false } : data.entity_scopes[scope];
  return {
    loadingScopePermissions: isLoading,
    scopePermissions: permissions,
    checkPermissions: (inEntity) => {
      var _a2;
      const entityScope = ((_a2 = inEntity == null ? void 0 : inEntity._scope) == null ? void 0 : _a2.toUpperCase()) || "DEFAULT";
      return data.entity_scopes[entityScope].is_mutable;
    }
  };
};
export default useGetPermissionsByScope;
